import React, { Component, Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import global from "../data/global.json";
import { Translate, withLocalize } from "react-localize-redux";

import stopwatchImg from "../images/stopwatch.png";
import reactWindowSize from "../libs/reactWindowSize.js";

let getURL = window.origin + window.public_url;



class Navigation extends Component {
  constructor(props) {
    super(props);

    this.onToggleOpen = this.onToggleOpen.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.lock = this.lock.bind(this);
    this.showOrientation = this.showOrientation.bind(this);
    this.state = {
      open: true,
      navShow: true,
      gated:window.gated =="true" || window.gated == "%REACT_APP_GATED%"
    };

    let ctaString = window.location.search.substring(1, window.location.search.length);
    if (ctaString.includes("site=zinfi")) {
      this.state.navShow = false;
    }
  }

  componentDidUpdate() {
    if (!!this.state.open) {
      document.body.classList.add("nav-open");
    } else {
      document.body.classList.remove("nav-open");
    }
  }

  showOrientation() {
    let { dispatch } = this.props;
    dispatch({
      type: "orientation/OPENED"
    });
  }

  lock() {
    let { dispatch } = this.props;
    dispatch({
      type: "navigation/LOCK"
    });
  }

  onToggleOpen(e) {
    let { dispatch } = this.props;

    if (this.state.open) {
      dispatch({
        type: "navigation/CLOSE"
      });
      this.setState({
        open: false
      });
    } else {
      dispatch({
        type: "navigation/OPEN"
      });
      this.setState({
        open: true
      });
    }

    e.stopPropagation();
    return false;
  }

  onMouseOver(index, e) {
    console.log("on mouse over", index);
    this.setState({
      displayIndex: index
    });
  }

  onMouseLeave(e) {
    console.log("on mouse leave", this.state.routeDisplayIndex);
    this.setState({
      displayIndex: undefined
    });
  }



  static getDerivedStateFromProps(props, state) {
    const { navigation, scene, location } = props;
    const { gated } = state;

    let open = navigation.open;
    let unlocked = !gated || (gated && navigation.unlocked);

    let pathnameParts = location.pathname.split("/").filter(Boolean);

    let selectedLevel1Path = pathnameParts.length
      ? pathnameParts[0]
      : global.defaultScene;
    let selectedLevel1Item = navigation.items.children.find(
      x => x.url == selectedLevel1Path
    );

    // if invalid, load default
    if (selectedLevel1Item == undefined || selectedLevel1Item.comingSoon) {
      selectedLevel1Item = navigation.items.children[0];
      pathnameParts = [];
    }

    let selectedLevel2Path =
      pathnameParts.length > 1
        ? pathnameParts[1]
        : selectedLevel1Item.children[0].url;

    let primaryItems = navigation.items.children.map(x => ({
      ...x,
      active: selectedLevel1Item ? x.url == selectedLevel1Item.url : false
    }));
    let secondaryItems = selectedLevel1Item.children.map(x => ({
      ...x,
      active: x.url == selectedLevel2Path,
      url: `/${selectedLevel1Item.url}/${x.url}`
    }));

    let allSecondaryItems = navigation.items.children.map(primary =>
      primary.children.map(secondary => ({
        ...secondary,
        active: secondary.url == selectedLevel2Path,
        url: `/${primary.url}/${secondary.url}`,
        comingSoon: primary.comingSoon
      }))
    );

    let displayIndex =
      state.displayIndex == undefined
        ? primaryItems.findIndex(x => x.active)
        : state.displayIndex;

    return {
      primaryItems,
      secondaryItems,
      allSecondaryItems,
      routeDisplayIndex: displayIndex,
      displayIndex: displayIndex,
      open,
      unlocked,
      showComingSoon: navigation.showComingSoon
    };
  }

  render() {
    const {
      primaryItems,
      secondaryItems,
      allSecondaryItems,
      open,
      unlocked,
      displayIndex,
      showComingSoon
    } = this.state;
    const { location, translate } = this.props;

    // Redirect to unlock route if scene locked and navigation is not unlocked
    let redirectEl;
    primaryItems.forEach(function(item, index) {
      if (
        !!item.active &&
        item.locked &&
        !unlocked &&
        location.pathname.indexOf("/unlock") < 0
      ) {
        redirectEl = (
          <Redirect
      to={{
              pathname: location.pathname + "/unlock",
              search: location.search
            }}
          />
        );
      }
    });

    if (!!redirectEl) {
      return redirectEl;
    }

    return (
      <nav
        className={`navigation ${open ? "open" : ""}`}
        onClick={this.onToggleOpen}
        onMouseLeave={e => this.onMouseLeave(e)}
      >
        <div className="toggle-button" onClick={this.onToggleOpen}>
          <span />
          <span />
        </div>
        {open ? (
          <div className={"row" + (!!showComingSoon ? " coming-soon" : "")}>
            <div className="col-2 col-md-4 col-lg-3 col-xl-2 primary-col">
              <div className="primary">
                {primaryItems.map((item, index) => (
                  <Fragment key={index}>
                    <Link
                      key={item.url}
                      className={`${item.active ? "active" : ""} ${
                        !unlocked && item.locked ? "locked" : ""
                      } ${
                        !item.active && displayIndex === index ? "hover" : ""
                      }`}
                      to={{
                        pathname:
                          !unlocked && item.locked
                            ? `/${item.url}/unlock`
                            : `/${item.url}`,
                        search: this.props.location.search
                      }}
                      onMouseOver={e => this.onMouseOver(index, e)}
                    >
                      <Translate id={item.title} />
                    </Link>
                  </Fragment>
                ))}
              </div>
            </div>
            <div className="col-8 col-md-6 col-lg-7 col-xl-8">
              <div className="secondary">
                {allSecondaryItems.map((secondaryItem, index) => {
                  return index === displayIndex ? (
                    <div className="row" key={index}>
                      {secondaryItem.map(item => (
                        <div key={item.url} className="col-4">
                          <Link
                            className={`${item.active ? "active" : ""} ${
                              item.comingSoon ? "coming-soon" : ""
                            }`}
                            to={{
                              pathname: item.url,
                              search: this.props.location.search
                            }}
                          >
                            <Translate id={item.title} />
                          </Link>
                        </div>
                      ))}
                    </div>
                  ) : (
                    undefined
                  );
                })}
              </div>
            </div>
            <div className="col-2">
              <div className="row align-items-end ternary">
                <div className="col">
                  <div className={ this.state.navShow ? "share-container" : "zinfi" }>
                    <span><Translate id="navigationShare"/></span>
                    <ul className="share-links">
                      <li className="share-link">
                        <a
                          target="_blank"
                          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                            translate("socialTwitter")
                          )}&hashtags=${encodeURIComponent(
                            translate("socialTwitterHashTags")
                          )}&url=${encodeURIComponent(getURL)}`}
                        >
                          <i className="fa fa-twitter-square" />
                        </a>
                      </li>
                      <li className="share-link">
                        <a
                          target="_blank"
                          href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                            getURL
                          )}&title=${encodeURIComponent(
                            translate("socialLinkedIn")
                          )}`}
                        >
                          <i className="fa fa-linkedin-square" />
                        </a>
                      </li>
                      <li className="share-link">
                        <a
                          target="_blank"
                          href={`https://www.facebook.com/sharer/sharer.php?u=${getURL}&quote=${encodeURIComponent(
                            translate("socialFacebook")
                          )}`}
                        >
                          <i className="fa fa-facebook-square" />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <a
                    href="#"
                    className="help-button"
                    onClick={this.showOrientation}
                  >
                    <Translate id="navigationOpenHelp" />
                  </a>
                  <span>
                    <Translate
                      id="navigationCopyright"
                      data={{ year: new Date().getFullYear() }}
                    />
                  </span>
                </div>
              </div>
            </div>
            {!!showComingSoon && displayIndex > 0 && (
              <div className="coming-soon-overlay">
                <div className="coming-soon-message">
                  <img src={stopwatchImg} />
                  <span>Coming soon</span>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="row">
            <div className="col-2 col-md-4 col-lg-3 col-xl-2">
              <div className="primary">
                {primaryItems.map(item =>
                  item.active ? (
                    <span
                      key={`primary-${item.url}`}
                      className={item.active ? "active" : null}
                      to={{
                        pathname: "/" + item.url,
                        search: this.props.location.search
                      }}
                    >
                      <Translate id={item.title} />
                    </span>
                  ) : (
                    undefined
                  )
                )}
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-5 col-xl-6">
              <div className="secondary">
                <div className="row">
                  {secondaryItems.map(item =>
                    item.active ? (
                      <Link
                        key={`secondary-${item.url}`}
                        className={`${item.active ? "active" : ""} ${
                          item.comingSoon ? "coming-soon" : ""
                        }`}
                        to={{
                          pathname: item.url,
                          search: this.props.location.search
                        }}
                      >
                        <Translate id={item.title} />
                      </Link>
                    ) : (
                      undefined
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="col-2" />
            <div className="col-2">
              <div className="row align-items-end ternary">
                <div className="col">
                  <span>
                    <Translate
                      id="navigationCopyright"
                      data={{ year: new Date().getFullYear() }}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    navigation: state.navigation,
    scene: state.scene
  };
}

export default withLocalize(withRouter(connect(mapStateToProps)(Navigation)));



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx